var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('FilterComponent',{attrs:{"filter-object":_vm.filterObject},on:{"handleSubmit":_vm.handleSubmit}}),_c('TableComponent',{attrs:{"filter-object":_vm.filterObject},on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }